import dayjs from "@lib/dayjs";
import { NavLink } from "react-router-dom";

const CandidateRowCard = ({ data }) => {

    return (
        <NavLink
            to={`/candidate-applied-jobs`}
            // state={{ item: data }}
            // onClick={onClick}
            className="grid grid-cols-[1.1fr_1.4fr_0.4fr] gap-16 items-center py-5 border-b px-3 hover:bg-gray-50"
        >
            <div className="flex flex-col gap-1">
                <div className="flex items-center justify-between">
                    <span className="text-[10px] text-light-black font-medium pl-2">
                        CA-872364
                    </span>
                    <span className={`font-medium text-[10px] ${data?.status !== 'expired' ? 'text-green-600' : 'text-gray-500'}`}>{data?.status !== 'expired' ? 'Available to work' : 'Expired'}</span>
                </div>
                <div className={`flex gap-4 rounded-md py-2.5 px-5 border border-y-gray-100 border-r-gray-100 border-green-600 border-l-[3px]`}>
                    <div className="w-[35px] h-[35px] bg-gray-100 rounded-full">
                        <img src={data?.profileImage} className="w-full h-full object-cover rounded-full" />
                    </div>
                    <div className="flex flex-col gap-0.5 text-primary">
                        <span className="text-xs font-bold line-clamp-1">{data?.fullName}</span>
                        <span className="text-xss font-medium">{data?.jobTitle}</span>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-1">
                <div className="flex items-center gap-5 h-[1rem] text-xss text-light-black font-medium italic">
                    <>
                        <span>
                            {dayjs(data?.latestTrackerDetails?.createdAt).format("hh:mm a")}
                        </span>
                        <span>
                            {dayjs(data?.latestTrackerDetails?.createdAt).format("Do MMM YY")}
                        </span>
                    </>
                </div>

                <div className="flex items-center bg-[#fafafa] border border-gray-200 rounded-md h-[3.8rem] py-3 px-3">
                    <span className="text-xs font-medium text-primary">You applied for the position titled <span className="font-bold">{data?.jobTitle}</span></span>
                </div>
            </div>
            <div className="flex flex-col items-center text-xss gap-2">
                Applied Jobs
                <div className="relative w-[53px] h-[53px] flex items-center justify-center">
                    {/* Glow layer */}
                    {/* {data?.unViewedApplicants ? (
                        <span className="absolute inset-0 rounded-full bg-green-500 opacity-5 animate-pulse"></span>
                    ) : null} */}

                    {/* Badge */}
                    <div
                        className={`relative z-10 w-[53px] h-[53px] rounded-full border-[3.5px] ${data?.totalJobs ? data?.status !== 'expired' ? "border-green-500" : "border-gray-500" : "border-gray-500"
                            } flex items-center justify-center`}
                    >
                        <span className="text-xs font-semibold text-black">
                            {data?.totalJobs}
                        </span>
                    </div>
                </div>
            </div>        </NavLink>
    );
};

export default CandidateRowCard